import {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useGetOne } from "react-admin";
import CustomMessage from "../../unit/CustomMessage";
import CustomPaper from "../../unit/CustomPaper";
import CustomTable from "../../unit/CustomTable";
import CustomTableContainer from "../../unit/CustomTableContainer";
import formatCurrency from "../../unit/formatCurrency";
import formatDate from "../../unit/formatDate";
import formatPercentage from "../../unit/formatPercentage";
import useNotify from "../../unit/useNotify";

const TableCellRight = styled(TableCell)({ textAlign: "right" });

const LoanOriginalTermsLog = ({ ...props }) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const appId = props.appId;
  //loan/paymentschedule/current/appId
  const { data, error, isLoading, isPending, isFetching } = useGetOne(
    "loan/paymentschedule/modifyPayment",
    { id: appId }
  );
  if (isPending || isFetching) {
    return <Typography sx={{ p: 5 }}>Loading...</Typography>;
  }
  if (error) return <CustomMessage message="Error loading Loan" />;
  if (!data) return <CustomMessage message="No data found for this id" />;
  // const modifyLogData = data.modifyData;
  const beforeModifyData = data.beforeModifyData;

  return (
    <>
      <CustomTableContainer component={CustomPaper}>
        <CustomTable stickyHeader id="table-loan-summary-modification-log-list">
          <TableHead>
            <TableRow>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Note Date
              </TableCell>
              <TableCell align="right" className="hm-table-header">
                Principal Amount
              </TableCell>
              <TableCell align="left" className="hm-table-header">
                Interest Rate
              </TableCell>
              <TableCell sx={{ minWidth: "150px" }} className="hm-table-header">
                First Payment <br />
                Date
              </TableCell>
              <TableCell className="hm-table-header">
                Payment Frequency
              </TableCell>
              <TableCell className="hm-table-header">Term (Months)</TableCell>
              <TableCell align="right" className="hm-table-header">
                Payment Amount
              </TableCell>
              <TableCell sx={{ minWidth: "120px" }} className="hm-table-header">
                Maturity <br />
                Date
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {beforeModifyData &&
              beforeModifyData.map((item: any) => (
                <TableRow key={item.iId} sx={{ background: "#e8e7e7ff" }}>
                  <TableCell className="dateText">
                    {formatDate(item.dOriginalNoteDate)}
                  </TableCell>
                  <TableCell className="amountText">
                    {formatCurrency(item.iLoanAmount)}
                  </TableCell>
                  <TableCell className="numericText">
                    {formatPercentage(item.iRate / 100)}
                  </TableCell>
                  <TableCell className="dateText">
                    {formatDate(item.dFirstPaymentDate)}
                  </TableCell>
                  <TableCell>{item.sPaymentFrequency}</TableCell>
                  <TableCell className="numericText">
                    {item.iRemainingPayments}
                  </TableCell>
                  <TableCell className="amountText">
                    {item?.sPaymentAmountDue &&
                      formatCurrency(item.sPaymentAmountDue)}
                  </TableCell>
                  <TableCell className="dateText">
                    {formatDate(item.dMaturityDate)}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </CustomTable>
      </CustomTableContainer>
    </>
  );
};

export default LoanOriginalTermsLog;
